import { VisitType } from '@enums/visit-type.enum';
import { EntityTypePrefix } from '@features/Calendar/constants';
export function isTimeOff(event) {
    return event.key.startsWith('TimeOff');
}
export function isGenericEvent(event) {
    return event.key.startsWith(EntityTypePrefix.Generic_event);
}
export function isVisit(event) {
    const keyPrefixes = [VisitType.INSPECTION_PRIMARY_VISIT, VisitType.SERVICE_VISIT];
    return keyPrefixes.some((prefix) => event.key.startsWith(prefix));
}
